// What a copy that was the first on the site gets on top of its reveal: the
// "First on n450s" stamp (tilted, a band in the tier's colour), the ring of small
// crowns and sparks round the badge in the cinematic, and the "first" chip on a tile.
import React from "react";
import { FIRST_STAMP_TEXT, tierColor } from "../collection/badgeFormat";

/** Slams in on mount; under reduced motion it fades in. */
export const FirstStamp: React.FC<{ tier: string; reduced?: boolean; className?: string }> = ({ tier, reduced = false, className }) => (
  <span
    className={["bdg-stamp", reduced ? "bdg-stamp--reduced" : "", className ?? ""].filter(Boolean).join(" ")}
    style={{ "--stamp-tier": tierColor(tier) } as React.CSSProperties}
    data-testid="badge-first-stamp"
  >
    {FIRST_STAMP_TEXT}
  </span>
);

const CROWN = (
  <svg viewBox="0 0 26 22" aria-hidden="true" focusable="false">
    <path
      d="M3 8.5 L8 12.5 L13 3.5 L18 12.5 L23 8.5 L21 18.5 L5 18.5 Z"
      fill="currentColor"
      stroke="#000"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle cx="13" cy="3" r="2" fill="#fff" stroke="#000" strokeWidth="1.5" />
    <circle cx="3" cy="8" r="1.7" fill="#fff" stroke="#000" strokeWidth="1.5" />
    <circle cx="23" cy="8" r="1.7" fill="#fff" stroke="#000" strokeWidth="1.5" />
  </svg>
);

const SPARK = (
  <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <path d="M10 1 L12 8 L19 10 L12 12 L10 19 L8 12 L1 10 L8 8 Z" fill="#fff" stroke="#000" strokeWidth="1.4" strokeLinejoin="round" />
  </svg>
);

/**
 * Small gold crowns and white sparks round the badge, popping in one after the
 * other round the circle, then turning slowly. The crowns stay upright while the
 * ring turns. Sized from the stage's --art.
 */
export const CrownRing: React.FC<{ count?: number }> = ({ count = 12 }) => (
  <div className="bdg-crowns" aria-hidden="true" data-testid="badge-crown-ring">
    <div className="bdg-crowns__spin">
      {Array.from({ length: count }, (_, i) => {
        const crown = i % 2 === 0;
        return (
          <span
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            className={`bdg-crowns__item bdg-crowns__item--${crown ? "crown" : "spark"}`}
            style={{ "--a": `${Math.round((360 / count) * i)}deg`, "--d": `${i * 55}ms` } as React.CSSProperties}
          >
            <span className="bdg-crowns__upright">
              <span className="bdg-crowns__glyph">{crown ? CROWN : SPARK}</span>
            </span>
          </span>
        );
      })}
    </div>
  </div>
);

/** The small chip a tile shows for a first-on-the-site copy. */
export const FirstChip: React.FC = () => (
  <span className="bdg-first-chip" title="First on the site">
    first
  </span>
);
